import React from 'react';

import Header from '../../layout/Header.jsx';
import ListAdmins from '../../lists/ListAdmins.jsx';

const PageAdmins = () => (
  <div>
    <Header>Admins</Header>
    <ListAdmins />
  </div>
);

export default PageAdmins;
